export default __webpack_public_path__ + "static/media/services01.9274290c.jpg";